<h2
  mat-dialog-title
  mat-dialog-draggable-title
  style="margin-bottom: 0px !important"
>
  <span *ngIf="data.type === 1">{{ "form.select_procedure_full" | translate }}</span>
  <span *ngIf="data.type === 2">{{ "form.select_procedure_private" | translate }}</span>
  <button type="button" class="close" aria-label="Close" mat-dialog-close (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography" style="max-height: 65vh;">
  <mat-card-content class="mat-elevation-z0 pt-2">
    <form nz-form class="mat-elevation-z0">
      <div class="row">
        <div class="col-xl-6 col-sm-12">
          <mat-form-field>
            <mat-label>{{ "procedure.choose_procedure" | translate }}</mat-label>
            <mat-select
              name="procedure"
              id="procedure"
              [(ngModel)]="createContractService.procedureId"
              (selectionChange)="changeProcedure($event)"
            >
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="searchCtrl"
                  [placeholderLabel]="
                    'placeholder.search_procedure' | translate
                  "
                  [searching]="loadingSearchType"
                  [noEntriesFoundLabel]="'analysis.no_data' | translate"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let option of proceduresFilter" [value]="option.id">
                {{ option.procedureName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-card-content>
  <!--Bảng các bên ký kết-->
  <mat-card-content *ngIf="this.createContractService.procedureId && data.type === 1" class="mat-elevation-z0">
    <mat-panel-title class="mat-panel-title">
      {{ "form.contracting_parties" | translate }}
    </mat-panel-title>
    <!-- Nz-table set luồng chủ thể -->
    <form nz-form>
      <!-- <span class="float-right" *ngIf="this.valueSelect == '0' ">
  {{'enterprise_contract.panel_document.table_parties.guide_checkbox' | translate}}</span> -->
  <nz-table #partyRowTable nzBordered [nzData]="RECORD_PARTY_SIGN" [nzShowPagination]="false"
  [nzFrontPagination]="false"
  class="ant-table-no-placeholder-border-bottom no-ant-table-placeholder">
  <thead>
      <tr>
          <th class="text-center" nzWidth="55px">
              {{
              "enterprise_contract.panel_document.table_parties.header.order"
              | translate
              }}
          </th>
          <th class="text-center">
              {{
              "enterprise_contract.panel_document.table_parties.header.party_name"
              | translate
              }}
          </th>
          <th class="text-center" nzWidth="30%">
              {{
              "enterprise_contract.panel_document.table_parties.header.email"
              | translate
              }}
          </th>
          <th class="text-center" nzWidth="18%" colspan="2" *ngIf="!isNotAttestedUser">
              {{
              "enterprise_contract.panel_document.table_parties.header.phone"
              | translate
              }}
          </th>
        <th class="text-center" nzWidth="18%"  *ngIf="isNotAttestedUser">
          {{
          "enterprise_contract.panel_document.table_parties.header.phone"
            | translate
          }}
        </th>
<!--          <th nzWidth="25px" *ngIf="!isNotAttestedUser">-->
<!--              {{-->
<!--              "enterprise_contract.panel_document.table_parties.header.sign_no_login"-->
<!--              | translate-->
<!--              }}-->
<!--          </th>-->
          <th nzWidth="25px" *ngIf="this.valueSelect == '0'">
              {{
              "enterprise_contract.panel_document.table_parties.header.insert_infor"
              | translate
              }}
          </th>
          <th nzWidth="25px"></th>
      </tr>
  </thead>
  <tbody *ngFor="let data of partyRowTable.data">
      <tr class="editable-row">
          <!-- TT -->
          <td class="text-center" *ngIf="data.isCreatedSide">
             {{data.order}}
          </td>
        <td class="text-center" rowspan="2" *ngIf="!data.isCreatedSide">
          {{data.order}}
        </td>
          <!-- Tên -->
          <td class="word-break-line">
              {{ data.name }}
          </td>
          <!-- Email -->
          <td class="word-break-line">
              <div>{{ data.email }}</div>
          </td>

          <!-- Phone -->
          <td class="word-break-line" colspan="2" *ngIf="!isNotAttestedUser">
              <div>{{ data.phone }}</div>
          </td>
        <td class="word-break-line"  *ngIf="isNotAttestedUser">
          <div>{{ data.phone }}</div>
        </td>
<!--          <td class="text-center" *ngIf="!isNotAttestedUser">-->
<!--              <label nz-checkbox [(ngModel)]="data.isSignNoLogin"-->
<!--                  [ngModelOptions]="{ standalone: true }" *ngIf="!data.isCreatedSide"-->
<!--                  nzDisabled></label>-->
<!--          </td>-->
          <td class="text-center" *ngIf="data.isCreatedSide">
              <div class="d-flex">
                  <a (click)="isShowUserSignTable = !isShowUserSignTable"
                      *ngIf="data.isCreatedSide" style="transition: 0.3s; margin-left: 7px; display: flex; align-items: center;"
                      [ngStyle]="{'transform': !isShowUserSignTable ? 'rotate(0deg)' : 'rotate(180deg)'}">
                      <i class="fa fa-angle-down" aria-hidden="true" nzIcon
                          style="font-size: 17px; "
                          matTooltip="{{ (isShowUserSignTable ? 'tooltips.hidden' : 'tooltips.show') | translate }}"></i>
                  </a>
              </div>
          </td>
        <td class="text-center" *ngIf="!data.isCreatedSide" rowspan="2">
          <div class="d-flex">
            <a (click)="isShowUserSignTable = !isShowUserSignTable"
               *ngIf="data.isCreatedSide" style="transition: 0.3s; margin-left: 7px; display: flex; align-items: center;"
               [ngStyle]="{'transform': !isShowUserSignTable ? 'rotate(0deg)' : 'rotate(180deg)'}">
              <i class="fa fa-angle-down" aria-hidden="true" nzIcon
                 style="font-size: 17px; "
                 matTooltip="{{ (isShowUserSignTable ? 'tooltips.hidden' : 'tooltips.show') | translate }}"></i>
            </a>
          </div>
        </td>
      </tr>
      <tr *ngIf="!data.isCreatedSide">
        <td colspan="4" *ngIf="!isNotAttestedUser">
          <label nz-checkbox [(ngModel)]="data.isSignNoLogin" class="checkbox-disabled"
                 [ngModelOptions]="{ standalone: true }" *ngIf="!data.isCreatedSide" style="color:rgba(0, 0, 0, 0.87) !important; "
                 > {{'enterprise_contract.panel_document.table_parties.header.SNL' | translate}}</label>
          <label nz-checkbox [(ngModel)]="data.signConfig.showImage" class="checkbox-disabled" style="color:rgba(0, 0, 0, 0.87) !important; "
                 [ngModelOptions]="{ standalone: true }" *ngIf="!data.isCreatedSide && data.customerType !== 10000"
                 > {{'enterprise_contract.panel_document.table_parties.header.DSIS' | translate}}</label>
        </td>
        <td colspan="3" *ngIf="isNotAttestedUser">
          <label nz-checkbox [(ngModel)]="data.signConfig.showImage" class="checkbox-disabled" style="color:rgba(0, 0, 0, 0.87) !important; "
                 [ngModelOptions]="{ standalone: true }" *ngIf="!data.isCreatedSide && data.customerType !== 10000"
          > {{'enterprise_contract.panel_document.table_parties.header.DSIS' | translate}}</label>
        </td>
      </tr>
      <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
        <td [attr.rowspan]="RECORD_USER_PERFORM_SIGN.length + 4">
        </td>
        <td [attr.colspan]="setColspan(6)" style="padding: 0 !important;">
            <div class="mat-panel-title mat-panel-title_custom font-color-blue">
                {{ "form.order_of_approval_signing_contract_unit" | translate }}
            </div>
          <!-- Nz-table set luồng ký / duyệt-->

          <!-- End Nz-table set luồng ký / duyệt-->
        </td>
      </tr>

      <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable"
          class="text-primary"
      style="background: #fafafa;"
      >
      <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
        <div class="d-flex">
          <div style="width: 40px;padding: 6px 8px; border-right: 1px solid #d9d9d9;">
            {{
            "enterprise_contract.panel_document.table_users.header.order"
            | translate
            }}
          </div>
          <div class="d-flex justify-content-center" style="width: 100%; align-items: center;">
            {{
            "enterprise_contract.panel_document.table_users.header.name"
            | translate
            }}
          </div>
        </div>
      </td>
      <td></td>
      </tr>
      <!-- Người dùng phê duyệt hợp đồng -->
      <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
        <td [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
          <div class="d-flex align-items-center">
            <div class="w-100 mat-panel-title_custom font-color-blue" style="padding-left: 10px; margin-right: 3rem;">
              {{ "form.contract_approver" | translate}} &nbsp;
            </div>
            <div class="text-center mat-panel-title_custom font-color-blue"
                 style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
              {{"enterprise_contract.panel_document.table_parties.header.sig_cts" | translate}}
            </div>
            <div class="text-center mat-panel-title_custom font-color-blue"
              style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
              {{"enterprise_contract.panel_document.table_parties.header.display_signature" | translate}}
            </div>
          </div>
          </td>
        <td></td>
      </tr>

      <!-- Danh sách người dùng phê đuuyệt hợp đồng -->
      <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index"
        [hidden]="!(showTableMembers && data.isCreatedSide && isShowUserSignTable) || !(user.role !== '1' && data.isCreatedSide)">
        <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
            <div class="d-flex">
              <div style="width: 50px; max-width: 50px; padding: 15px 20px; border-right: 1px solid #d9d9d9;">
                {{ user.order }} </div>
                  <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                    <div class="editable-cell" *ngIf="user.userId != null">
                      <div *ngIf="user.departmentName" class="row-icon department"><span
                          class="material-icons">apartment</span>{{ user.departmentName }}</div>
                      <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                        {{user.name}} - {{user.email}} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                      <label nz-checkbox [(ngModel)]="user.isSignDigitalCertificate"
                             class="checkbox-disabled"
                             [ngModelOptions]="{ standalone: true }">
                      </label>
                    </div>
                    <div class="d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                      <ng-container *ngIf="user && user.isSignDigitalCertificate">
                        <label nz-checkbox [ngModel]="user?.signConfig?.showImage" class="checkbox-disabled"
                          [ngModelOptions]="{ standalone: true }">
                        </label>
                      </ng-container>
                    </div>
            </div>
        </td>
        <td class="text-center">
        </td>
      </tr>

      <!-- Tìm kiếm người dùng phê duyệt hợp đồng -->

      <!-- Người dùng Ký duyệt hợp đồng -->
      <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
        <td [attr.colspan]="setColspan(6)" style="padding: 0 !important;">
          <div class="mat-panel-title_custom font-color-blue" style="padding-left: 10px">
            {{ "form.user_signs_and_approves_the_contract" | translate}}
          </div>
        </td>
      </tr>

      <!-- Danh sách người dùng Ký đuuyệt hợp đồng -->
      <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index"
        [hidden]="!(showTableMembers && data.isCreatedSide && isShowUserSignTable) || !(user.role === '1' && data.isCreatedSide)">
        <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
          <div class="d-flex">
            <div style="width: 50px; max-width: 50px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
              1
            </div>
            <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
              <div class="editable-cell" *ngIf="user.userId != null">
                <div *ngIf="user.departmentName" class="row-icon department"><span
                    class="material-icons">apartment</span>{{ user.departmentName }}</div>
                <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                  {{user.name}} - {{user.email}} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></div>
              </div>
            </div>
          </div>
      </td>
      <td class="text-center">
      </td>
      </tr>
</tbody>
</nz-table>
    </form>
    <!-- End of Nz-table set chu the-->
  </mat-card-content>
  <!--Giao diện thiết lập luồng duyệt-ký hợp đồng nội bộ-->
  <mat-card-content
    class="mat-elevation-z0"
    *ngIf="this.createContractService.procedureId && data.type === 2"
  >
    <mat-panel-title class="mat-panel-title font-color-blue">
      {{ "form.order_of_approval_signing_contract_unit" | translate }}
    </mat-panel-title>
    <form nz-form>
      <nz-table #editRowTable nzBordered [nzData]="RECORD_USER_PERFORM_SIGN" [nzShowPagination]="false"
                    [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                        <tr>
                            <th class="text-center" nzWidth="25px">
                                {{
                                "enterprise_contract.panel_document.table_users.header.order"
                                | translate
                                }}
                            </th>
                            <th colspan="2" class="text-center" nzWidth="100%">
                                {{
                                "enterprise_contract.panel_document.table_users.header.name"
                                | translate
                                }}
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngIf="isShowUserApproveTable">
                        <!-- Người dùng phê duyệt hợp đồng -->
                        <tr>
                          <td [attr.colspan]="setColspan(3)" style="padding: 0 !important;">
                            <div class="d-flex align-items-center">
                              <div class="w-100 mat-panel-title_custom font-color-blue" style="padding-left: 10px; margin-right: 2rem;">
                                {{ "form.contract_approver" | translate}} &nbsp;
                              </div>
                              <div class="text-center mat-panel-title_custom font-color-blue"
                                   style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
                                {{"enterprise_contract.panel_document.table_parties.header.sig_cts" | translate}}
                              </div>
                              <div class="text-center mat-panel-title_custom font-color-blue"
                                style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
                                {{"enterprise_contract.panel_document.table_parties.header.display_signature" | translate}}
                              </div>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    <tbody *ngFor="let data of editRowTable.data; let i = index">
                        <tr class="editable-row" *ngIf="data.role !== '1'">
                          <td class="text-center" class="text-center" [attr.colspan]="setColspan(3)" style="padding: 0 !important;">
                            <div class="d-flex">
                                <div style="width: 50px; max-width: 50px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                                    {{ data.order }} </div>
                                        <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                                            <div class="editable-cell" *ngIf="data.userId != null">
                                                <div *ngIf="data.departmentName" class="row-icon department"><span
                                                        class="material-icons">apartment</span>{{ data.departmentName }}
                                                </div>
                                                <div class="row-icon word-break-line text-left"><span class="material-icons"
                                                        *ngIf="!data.departmentName">person</span>
                                                    {{data.name}} - {{data.email}} <span *ngIf="data.userPosition">- {{data.userPosition}}</span></div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                                            <label nz-checkbox [(ngModel)]="data.isSignDigitalCertificate"
                                                   class="checkbox-disabled"
                                                   [ngModelOptions]="{ standalone: true }">
                                            </label>
                                          </div>
                                          <div class="d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                                            <ng-container *ngIf="data && data.isSignDigitalCertificate">
                                              <label nz-checkbox [ngModel]="data?.signConfig?.showImage" class="checkbox-disabled"
                                                [ngModelOptions]="{ standalone: true }">
                                              </label>
                                            </ng-container>
                                          </div>
                                </div>
                          </td>
                        </tr>
                    </tbody>

                    <tbody>
                        <!-- Người dùng ký duyệt hợp đồng -->
                        <tr>
                            <td colspan="3" style="padding: 0 !important;">
                                <div class="mat-panel-title_custom font-color-blue">
                                    {{ "form.user_signs_and_approves_the_contract" | translate}}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngFor="let data of editRowTable.data; let i = index">
                        <tr class="editable-row" *ngIf="data.role === '1'">
                          <td class="text-center" colspan="3" style="padding: 0 !important;">
                            <div class="d-flex">
                                <div style="width: 50px; max-width: 50px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                                    1
                                </div>
                                <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                                    <div class="editable-cell" *ngIf="data.userId != null">
                                        <div *ngIf="data.departmentName" class="row-icon department"><span
                                                class="material-icons">apartment</span>{{ data.departmentName }}</div>
                                        <div class="row-icon word-break-line text-left"><span class="material-icons"
                                                *ngIf="!data.departmentName">person</span>
                                            {{data.name}} - {{data.email}} <span *ngIf="data.userPosition">- {{data.userPosition}}</span></div>
                                    </div>
                                </div>
                            </div>
                          </td>
                        </tr>
                    </tbody>

                </nz-table>
    </form>
  </mat-card-content>
</mat-dialog-content>
<mat-divider></mat-divider>
<div class="text-center mt-3">
  <button mat-stroked-button color="primary" class="mr-3"
          (click)="onNoClick()">
    <mat-icon class="mr-0">cancel</mat-icon>{{ "button.cancel" | translate }}
  </button>
  <button [disabled]="!this.createContractService.procedureId" mat-raised-button color="primary" (click)="confirm()">
    <mat-icon class="mr-0">save</mat-icon>
    <span>{{"button.choose" | translate}}</span>
  </button>
</div>
